export const sortVersionsDescending = (versions: string[]) =>
	versions.sort((a, b) => {
		const partsA = a.split(".").map(Number);
		const partsB = b.split(".").map(Number);
		for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
			const diff = (partsB[i] ?? 0) - (partsA[i] ?? 0);
			if (diff !== 0) return diff;
		}
		return 0;
	});
